import { SET_FEATURES, SET_MVT_PARAMS } from "./constants";

export const setFeatures = features => ({
  type: SET_FEATURES,
  payload: features
});

export const setMvtParams = params => ({
  type: SET_MVT_PARAMS,
  payload: params
});
